/*
 * Copyright (c) 2023-2024 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import { Badge } from 'antd'
import React from 'react'
import { BannerInfo } from '../../constants/icons/icons'

interface Props {
  children: React.ReactElement
  bannerInfo: BannerInfo | undefined
}

export function BadgeEnvironment({ children, bannerInfo }: Props) {
  if (!bannerInfo) return children

  const { color, text } = bannerInfo

  return (
    <Badge.Ribbon text={text} color={color} placement="start" className="-top-3 text-xs">
      {children}
    </Badge.Ribbon>
  )
}
